import React from 'react';
import { StatusPill } from '~/shared/StatusPill';
import { OrderStatusEnum } from '@generated';

export function OrderStatusPill({ order }: { order: { orderStatusId: number; orderStatusLabel: string } }) {
	return (
		<StatusPill
			intent={
				order.orderStatusId === OrderStatusEnum.Drafted || order.orderStatusId === OrderStatusEnum.WaitingCosignature
					? 'warning'
					: order.orderStatusId === OrderStatusEnum.InReview
					? 'info'
					: order.orderStatusId === OrderStatusEnum.Completed || order.orderStatusId === OrderStatusEnum.SentToPhysician
					? 'success'
					: 'destructive'
			}
			className="mt-1"
		>
			{order.orderStatusLabel}
		</StatusPill>
	);
}
